var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from '@reduxjs/toolkit';
import { request } from '../../config/request';
export const fetchJuOrju = createAsyncThunk('jurnal-or-jurnal/fetch', (_, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const response = yield request('/selectors/jurnal-or-jurnal');
        const mode = Number(response.data); // преобразуем "1" → 1
        /* Старый сервер присылает только data — тогда режим вуза тот же. */
        const env = response.env === undefined ? mode : Number(response.env);
        /* Сервер до настройки own_schedule признака не присылает — тогда
           функция доступна везде, где вуз не ведёт расписание в AVN. */
        const ownAllowed = response.ownAllowed === undefined ? env !== 1 : Boolean(response.ownAllowed);
        return { mode, env, own: Boolean(response.own), ownAllowed };
    }
    catch (e) {
        return thunkAPI.rejectWithValue('Ошибка');
    }
}));
